import React from 'react';
import { Form } from 'react-bootstrap';
import TextInput from '../TextInput';

function TextInputWithLabel({
  id,
  label,
  name,
  value, // state
  type,
  onChange,
  placeholder,
  labelClass,
  onFocus,
  style,
  disabled,
  onKeyDown,
  readOnly,
  required
}) {
  return (
    <Form.Group className='mb-2'>
      <Form.Label htmlFor={id} className={labelClass}>{label}
        {required && <span className="text-danger">*</span>}
      </Form.Label>
      <TextInput
        id={id}
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onFocus={onFocus}
        style={style}
        disabled={disabled}
        onKeyDown={onKeyDown}
        readOnly={readOnly}
      />
    </Form.Group>
  );
}

export default TextInputWithLabel;
